<nav
  class="sidebar"
  [@slideInOut]="collapsed ? 'collapsed' : 'expanded'"
  [class.collapsed]="collapsed"
  [style.background-color]="colors.background"
  [style.border-right-color]="colors.borderColor">
  <div class="sidebar-header" [style.border-bottom-color]="colors.borderColor">
    @if (!collapsed) {
      <div class="sidebar-logo">
        <img
          src="assets/logos/logo-full.svg"
          alt="EWHMS Stock Count"
          width="180"
          height="95" />
      </div>
    }
    <button
      type="button"
      class="sidebar-toggle"
      (click)="toggleSidebar()"
      (mouseenter)="onToggleHover($event, true)"
      (mouseleave)="onToggleHover($event, false)"
      [attr.aria-label]="collapsed ? 'Expand sidebar' : 'Collapse sidebar'"
      [style.color]="colors.toggleColor">
      <tui-icon
        [icon]="collapsed ? 'mat::arrow_right' : 'mat::arrow_back'"></tui-icon>
    </button>
  </div>

  <ul class="sidebar-menu">
    @for (item of items; track $index) {
      @if (isItemVisible(item)) {
        <li
          class="sidebar-item"
          [class.has-children]="item.children && item.children.length > 0"
          [class.disabled]="item.disabled">
          <!-- Custom component rendering -->
          @if (item.component) {
            <ng-container *polymorpheusOutlet="item.component"></ng-container>
          }
          <!-- Standard menu item -->
          @if (!item.component) {
            <!-- Parent menu item -->
            <a
              class="sidebar-link"
              [href]="item.route || item.url || '#'"
              [class.active]="item.route && router.isActive(item.route, false)"
              (click)="handleParentNavigationClick($event, item, $index)"
              (mouseenter)="
                onLinkHover(
                  $event,
                  true,
                  item.route && router.isActive(item.route, false)
                )
              "
              (mouseleave)="
                onLinkHover(
                  $event,
                  false,
                  item.route && router.isActive(item.route, false)
                )
              "
              [attr.aria-expanded]="
                item.children && item.children.length > 0
                  ? isItemExpanded($index)
                  : null
              "
              [attr.title]="collapsed ? item.label : null"
              [style.color]="
                item.route && router.isActive(item.route, false)
                  ? colors.activeTextColor
                  : colors.textColor
              "
              [style.background-color]="
                item.route && router.isActive(item.route, false)
                  ? colors.activeBackground
                  : ''
              "
              [style.border-left]="
                item.route && router.isActive(item.route, false)
                  ? '4px solid ' + colors.activeBorderColor
                  : ''
              "
              [style.cursor]="'pointer'"
              [style.position]="'relative'"
              [style.z-index]="'1'">
              @if (item.icon) {
                <span
                  class="sidebar-icon"
                  [class.has-expanded-submenu]="
                    collapsed &&
                    item.children &&
                    item.children.length > 0 &&
                    isItemExpanded($index)
                  ">
                  <tui-icon [icon]="item.icon"></tui-icon>
                  @if (
                    collapsed &&
                    item.children &&
                    item.children.length > 0 &&
                    isItemExpanded($index)
                  ) {
                    <span class="submenu-indicator"> </span>
                  }
                </span>
              }
              @if (!collapsed) {
                <span class="sidebar-label">
                  {{ item.label }}
                </span>
              }
              @if (!collapsed && item.children && item.children.length > 0) {
                <span
                  class="sidebar-arrow"
                  [@rotateIcon]="
                    isItemExpanded($index) ? 'expanded' : 'collapsed'
                  ">
                  <tui-icon icon="mat::arrow_right"></tui-icon>
                </span>
              }
            </a>
            <!-- Submenu items in collapsed state - show as individual icons only when expanded -->
            @if (
              collapsed &&
              item.children &&
              item.children.length > 0 &&
              isItemExpanded($index)
            ) {
              @for (subItem of item.children; track $index) {
                @if (isItemVisible(subItem) && subItem.icon) {
                  <a
                    class="sidebar-link sidebar-subicon"
                    [href]="subItem.route || subItem.url || '#'"
                    [class.active]="
                      subItem.route && router.isActive(subItem.route, true)
                    "
                    (click)="handleNavigationClick($event, subItem)"
                    [attr.title]="subItem.label"
                    [style.color]="
                      subItem.route && router.isActive(subItem.route, true)
                        ? colors.activeTextColor
                        : colors.textColor
                    "
                    [style.background-color]="
                      subItem.route && router.isActive(subItem.route, true)
                        ? colors.submenuActiveBackground
                        : ''
                    "
                    [style.cursor]="'pointer'"
                    [@fadeInOut]>
                    <span class="sidebar-icon">
                      <tui-icon [icon]="subItem.icon"></tui-icon>
                    </span>
                  </a>
                }
              }
            }
            <!-- Submenu in expanded state -->
            @if (item.children && item.children.length > 0 && !collapsed) {
              <ul
                class="sidebar-submenu"
                [@expandCollapse]="
                  isItemExpanded($index) ? 'expanded' : 'collapsed'
                "
                [style.overflow]="isItemExpanded($index) ? 'visible' : 'hidden'"
                [style.background-color]="colors.submenuBackground">
                @for (subItem of item.children; track $index) {
                  @if (isItemVisible(subItem)) {
                    <li
                      class="sidebar-subitem"
                      [class.disabled]="subItem.disabled">
                      <!-- Custom component in submenu -->
                      @if (subItem.component) {
                        <ng-container
                          *polymorpheusOutlet="
                            subItem.component
                          "></ng-container>
                      }
                      <!-- Standard submenu item -->
                      @if (!subItem.component) {
                        <a
                          class="sidebar-sublink"
                          [href]="subItem.route || subItem.url || '#'"
                          [class.active]="
                            subItem.route &&
                            router.isActive(subItem.route, true)
                          "
                          (click)="handleNavigationClick($event, subItem)"
                          (mouseenter)="
                            onSubLinkHover(
                              $event,
                              true,
                              subItem.route &&
                                router.isActive(subItem.route, true)
                            )
                          "
                          (mouseleave)="
                            onSubLinkHover(
                              $event,
                              false,
                              subItem.route &&
                                router.isActive(subItem.route, true)
                            )
                          "
                          [style.color]="
                            subItem.route &&
                            router.isActive(subItem.route, true)
                              ? colors.activeTextColor
                              : colors.textColor
                          "
                          [style.background-color]="
                            subItem.route &&
                            router.isActive(subItem.route, true)
                              ? colors.submenuActiveBackground
                              : ''
                          ">
                          @if (subItem.icon) {
                            <span
                              class="sidebar-icon"
                              (click)="onIconClick($event, subItem, $index)"
                              [style.cursor]="'pointer'">
                              <tui-icon [icon]="subItem.icon"></tui-icon>
                            </span>
                          }
                          <span class="sidebar-label">
                            {{ subItem.label }}
                          </span>
                        </a>
                      }
                    </li>
                  }
                }
              </ul>
            }
          }
        </li>
      }
    }
  </ul>

  <!-- Collapsed state tooltips -->
  @if (collapsed) {
    <div class="sidebar-tooltips">
      @for (item of items; track $index) {
        @if (isItemVisible(item) && !item.component) {
          <div
            class="sidebar-tooltip"
            [attr.data-index]="$index"
            tuiHint
            [tuiHintContent]="item.label"
            tuiHintDirection="right"></div>
        }
      }
    </div>
  }

  <!-- CIT Logo at bottom -->
  @if (!collapsed) {
    <div class="sidebar-footer">
      <a
        href="https://www.connectit.gr"
        target="_blank"
        rel="noopener noreferrer"
        class="cit-logo-link">
        <img src="assets/logos/cit-logo.png" alt="CIT" class="cit-logo" />
      </a>
      <div class="app-info">
        <div class="app-version">v1.0.0</div>
        <div class="app-year">© 2025</div>
      </div>
    </div>
  }
</nav>
